import * as constants from '../constants';

export default class Stepper {
  /**
   * @constructor
   * @param {number} min          - integer
   * @param {number} max          - integer
   * @param {number} increment    - integer
   * @param {number} initialValue - integer
   * @param {string} label        - integer
   */
  constructor(min, max, increment, initialValue) {
    this.sprite = new PIXI.Sprite();

    const tfBorder = new PIXI.Graphics();
    this.sprite.addChild(tfBorder);
    tfBorder
    .clear()
    .lineStyle(4, 0xFFFFFF)
    .drawRect(-23, -23, 46, 46);

    this.tf = new PIXI.Text(initialValue, {
      font: '24px Open Sans, Arial',
      fill: 0xFFFFFF,
      align: 'center',
      letterSpacing: 2
    });

    const arrowStyle = {
      font: '32px Flaticons Stroke',
      fill: 0xFFFFFF,
      align: 'center'
    };

    const up = new PIXI.Text(constants.upArrow, arrowStyle);
    const down = new PIXI.Text(constants.downArrow, arrowStyle);

    const upSprite = new PIXI.Sprite();
    const downSprite = new PIXI.Sprite();
    upSprite.addChild(up);
    downSprite.addChild(down);

    upSprite.interactive = true;
    downSprite.interactive = true;
    upSprite.cursor = 'pointer';
    downSprite.cursor = 'pointer';

    this.sprite.addChild(upSprite);
    this.sprite.addChild(this.tf);
    this.sprite.addChild(downSprite);

    up.anchor.set(0.5);
    this.tf.anchor.set(0.5);
    down.anchor.set(0.5);

    upSprite.y = -38;
    downSprite.y = 45;

    this.sprite.interactive = true;
    this.sprite.hitArea = new PIXI.Rectangle(-15, -50, 30, 100);

    this.sprite.on('pointerdown', function ( e ) {
      const localY = this.sprite.toLocal(e.data.global).y;
      if ( Math.abs(localY) < 30 ) {
        return;
      }

      const inc = localY > 0 ? -increment : increment;

      let val = this.value + inc;
      if ( val < min ) {
        val = max;
      } else if ( val > max ) {
        val = min;
      }

      this.tf.text = val;
    }, this);
  }

  get value() {
    return parseInt(this.tf.text, 10);
  }
}
